// leaf-town - the town, the school, the FIRST FIVE coworking office and the Starbox cafe: walk, go through doors, sit down, say hello
(function () {
  'use strict';
  const G = window.G, W = G.W, H = G.H, C = G.COL, K = C.ink, S = G.SPR, A = G.audio, T = 16;
  const SV = () => G.save.data;
  const GY = 184;                                            // street level
  const SPEED = 96, JUMP = 250, DASH = 320, DASH_T = 0.15, DASH_CD = 0.2;   // dash numbers match the stage hero's bash
  const bump = (x, c, w, h) => (Math.abs(x - c) < w ? h * (0.5 + 0.5 * Math.cos(((x - c) / w) * Math.PI)) : 0);

  // ---------- painting helpers ----------
  const LIT = '#ffd97a', LITLO = '#f2b24e', LITHI = '#fff1b8', FRAME = '#2a2338';
  function windowAt(p, x, y, w, h, lit, lights) {
    p.rect(x - 1, y - 1, w + 2, h + 2, FRAME);
    p.rect(x, y, w, h, lit ? LIT : '#1a2238');
    if (lit) { p.rect(x, y + h - 3, w, 3, LITLO); p.rect(x + 1, y + 1, 1, h - 5, LITHI); lights.push({ x: x + w / 2, y: y + h / 2, r: w + 14, col: '#ffc978', a: 0.9, glow: 0.22 }); }
    else { p.px(x + w - 3, y + 2, '#5a6a9a').px(x + w - 4, y + 3, '#3a4a7a'); }
    p.rect(x + (w >> 1), y, 1, h, FRAME); p.rect(x, y + (h >> 1), w, 1, FRAME);
    p.rect(x - 2, y + h + 1, w + 4, 2, '#6a5872');
  }
  function doorAt(p, x, y, w, h, wood, lights) {
    p.rect(x - 2, y - 3, w + 4, h + 3, FRAME);
    p.rect(x, y, w, h, wood);
    p.rect(x, y, w, 1, G.mix(wood, '#ffffff', 0.2));
    p.rect(x + 3, y + 3, w - 6, Math.min(8, h >> 2), LIT).rect(x + 3, y + 3 + Math.min(8, h >> 2) - 2, w - 6, 2, LITLO);
    p.rect(x + 3, y + h - 12, w - 6, 8, G.mix(wood, '#000000', 0.25));
    p.rect(x + w - 5, y + (h >> 1) + 2, 2, 2, C.gold);
    lights.push({ x: x + w / 2, y: y + 6, r: w + 10, col: '#ffc978', a: 0.7, glow: 0.18 });
  }
  function tree(p, x, base) {
    p.rect(x - 2, base - 26, 4, 26, '#2a1c18').rect(x - 2, base - 26, 1, 26, '#3a2a22');
    p.ell(x, base - 38, 16, 14, '#1d4d47').ell(x - 8, base - 30, 9, 8, '#1d4d47').ell(x + 8, base - 31, 10, 9, '#1d4d47');
    p.ell(x + 3, base - 27, 10, 4, '#163a3a').ell(x - 5, base - 44, 7, 5, '#2f6e5c').ell(x - 10, base - 33, 3, 3, '#2f6e5c');
  }
  function lamp(p, x, base, lights) {
    p.rect(x - 3, base - 3, 6, 3, FRAME).rect(x - 1, base - 44, 2, 41, FRAME).rect(x - 1, base - 44, 1, 41, '#3a3346');
    p.rect(x - 3, base - 52, 6, 2, FRAME).rect(x - 2, base - 50, 4, 5, '#fff3c4').rect(x - 2, base - 46, 4, 1, '#f2c14e').rect(x - 3, base - 45, 6, 1, FRAME);
    lights.push({ x, y: base - 48, r: 58, col: '#ffe2a0', a: 1, glow: 0.3, flick: 1 });
  }
  function fence(p, x0, x1, base) {
    for (let x = x0; x < x1; x += 8) p.rect(x, base - 14, 3, 14, '#6a4a34').rect(x, base - 15, 3, 1, '#8a6248').px(x + 1, base - 16, '#6a4a34');
    p.rect(x0, base - 11, x1 - x0, 2, '#5a3a2a').rect(x0, base - 5, x1 - x0, 2, '#5a3a2a');
  }
  function cobbles(p, x0, x1) {
    p.rect(x0, GY, x1 - x0, 5, '#3a3346');
    for (let x = x0, i = 0; x < x1; x += 7, i++) { p.rect(x, GY, Math.min(6, x1 - x), 2, '#6b6578').rect(x + 3, GY + 2, Math.min(6, x1 - x - 3), 2, '#5a5568'); p.px(x, GY, '#8d8798'); }
  }
  function house(p, x, w, h, wall, roof, lights, seed) {
    const r = G.rng(seed), top = GY - h;
    p.rect(x + w - 12, top - 22, 6, 14, '#3a3046').rect(x + w - 13, top - 23, 8, 2, '#4a3a52');           // chimney
    p.rect(x, top, w, h, wall);
    for (let y = top + 5; y < GY; y += 6) p.rect(x, y, w, 1, G.mix(wall, '#000000', 0.12));
    const rh = 18;
    for (let j = 0; j < rh; j++) p.rect(x - 4 + j, top - j - 1, w + 8 - j * 2, 1, j % 4 === 3 ? G.mix(roof, '#000000', 0.25) : roof);
    p.rect(x - 4, top - 1, w + 8, 1, G.mix(roof, '#ffffff', 0.18));
    doorAt(p, x + 8, GY - 22, 12, 22, '#5a3a2a', lights);
    windowAt(p, x + w - 26, top + 10, 14, 12, r() < 0.75, lights);
    if (w > 70) windowAt(p, x + 30, top + 10, 14, 12, r() < 0.6, lights);
  }

  // ---------- seats ----------
  // The seat table lives in shared/world/seats.ts (one row per seat; the row's index is its id on the wire). G.WORLD.tablesOf(room) hands it over
  // as tables: { id, no (table number), kind, x, seats: [{ id, x, y, face, back }] }. Sitting records { room, table, seat } in G.seated:
  // the net bridge sends the seat id, and everyone at the same table number shares a meeting (stage 2).
  const R = G.WORLD.rooms, tablesOf = G.WORLD.tablesOf;
  G.seated = null;

  function chair(p, s, col, wood) {
    const lo = G.mix(col, '#000000', 0.3), hi = G.mix(col, '#ffffff', 0.25), fy = s.back ? s.y + 8 : GY, rear = s.face > 0 ? s.x - 7 : s.x + 5;
    p.rect(rear, s.y - 11, 2, 14, lo).rect(rear - (s.face > 0 ? 0 : 1), s.y - 12, 3, 2, lo);
    p.rect(s.x - 6, s.y, 12, 3, col).rect(s.x - 6, s.y, 12, 1, hi);
    if (wood) p.rect(s.x - 5, s.y + 3, 2, fy - s.y - 3, lo).rect(s.x + 3, s.y + 3, 2, fy - s.y - 3, lo);
    else p.rect(s.x - 1, s.y + 3, 2, fy - s.y - 4, FRAME).rect(s.x - 5, fy - 2, 10, 2, FRAME);
  }
  // a raised hand (7x7 pixels, bobbing) centered on x with its top edge at y
  const HAND = ['.#.#.#.', '.#.#.#.', '.#####.', '#######', '#######', '.#####.', '..###..'];
  function drawHand(ug, x, y, t) {
    const dy = Math.sin(t * 6) > 0 ? 0 : -1, x0 = Math.round(x) - 3, y0 = Math.round(y) + dy;
    ug.fillStyle = K; HAND.forEach((row, j) => { for (let i = 0; i < 7; i++) if (row[i] === '#') ug.fillRect(x0 + i - 1, y0 + j - 1, 3, 3); });
    ug.fillStyle = '#ffd97a'; HAND.forEach((row, j) => { for (let i = 0; i < 7; i++) if (row[i] === '#') ug.fillRect(x0 + i, y0 + j, 1, 1); });
  }
  // a speech bubble over a head (same box as the talk bubble, a little smaller), a mic dot and a screen icon next to a name
  function drawSay(ug, x, y, text) {
    let lines = G.kwrap(text, 110); if (lines.length > 3) lines = [...lines.slice(0, 2), lines[2].slice(0, -1) + '…'];
    const bw = Math.max(...lines.map(G.ktextW)) + 12, bh = lines.length * 12 + 8, bx = Math.round(G.clamp(x - bw / 2, 2, W - bw - 2)), by = Math.max(2, Math.round(y - bh));
    G.panel(ug, bx, by, bw, bh, '#17131f', C.paper, '#0d0a12');
    ug.fillStyle = C.paper; ug.fillRect(G.clamp(x, bx + 4, bx + bw - 6), by + bh, 3, 2);
    lines.forEach((ln, i) => G.ktext(ug, ln, bx + 6, by + 4 + i * 12, C.paper));
  }
  // cut a line to fit a pixel width, ending in …
  function fitText(str, maxW) { if (G.ktextW(str) <= maxW) return str; let n = str.length; while (n > 1 && G.ktextW(str.slice(0, n) + '…') > maxW) n--; return str.slice(0, n) + '…'; }
  const SCREEN_IC = ['.#####.', '#.....#', '#.....#', '#.....#', '.#####.', '..###..'];
  function drawIcon(ug, rows, x, y, col) {
    ug.fillStyle = K; rows.forEach((row, j) => { for (let i = 0; i < row.length; i++) if (row[i] === '#') ug.fillRect(x + i - 1, y + j - 1, 3, 3); });
    ug.fillStyle = col; rows.forEach((row, j) => { for (let i = 0; i < row.length; i++) if (row[i] === '#') ug.fillRect(x + i, y + j, 1, 1); });
  }
  const STAR = ['..#..', '..#..', '#####', '.###.', '.#.#.'];
  // Starbox house style (our own badge, not anyone's real logo): deep green, cream, walnut, brass
  const SB = { green: '#0f6b48', deep: '#0b4a33', dark: '#082e21', cream: '#f4ead2', walnut: '#3a2418', walnut2: '#4a3020', brass: '#c9a050', brassHi: '#f0d488' };
  const STAR7 = ['...#...', '..###..', '#######', '.#####.', '..###..', '.##.##.', '.#...#.'];
  // the round badge: green disc, cream ring, cream star with two little leaves. Small sizes keep only the star dot
  function emblem(p, x, y, r) {
    const g = p.g;
    G.disc(g, x, y, r + 1, K); G.disc(g, x, y, r, SB.green);
    if (r < 6) { p.rect(x - 1, y - 1, 3, 3, SB.cream).px(x, y, SB.green); return; }
    G.ring(g, x, y, r - 2, SB.cream); G.disc(g, x, y, r - 3, SB.deep);
    p.rows(x - 3, y - 4, STAR7, { '#': SB.cream });
    p.rect(x - 6, y + 2, 2, 1, SB.cream).rect(x - 5, y + 3, 2, 1, SB.cream).rect(x + 5, y + 2, 2, 1, SB.cream).rect(x + 4, y + 3, 2, 1, SB.cream);
  }
  // a takeaway cup: cream cup, kraft sleeve, green badge dot, dark lid
  function sbCup(p, x, base) {
    p.rect(x, base - 7, 5, 7, SB.cream).rect(x - 1, base - 8, 7, 1, '#2a2a2e').rect(x, base - 9, 5, 1, '#3a3a40');
    p.rect(x, base - 4, 5, 2, '#b98a5a').px(x + 2, base - 6, SB.green).rect(x + 4, base - 7, 1, 7, '#d8ccb0');
  }
  function plant(p, x, base, tall) {
    p.rect(x - 5, base - 12, 10, 12, '#8c5e36').rect(x - 5, base - 12, 10, 2, '#c08a4e');
    const h = tall ? 26 : 12;
    p.ell(x, base - 12 - h / 2, 7, h / 2 + 2, '#3f8a55').ell(x - 3, base - 14 - h * 0.7, 4, 4, '#5fb86f').ell(x + 4, base - 14 - h * 0.35, 3, 4, '#2f7a52');
    if (tall) p.ell(x - 5, base - 20, 4, 6, '#3f8a55').ell(x + 5, base - 30, 4, 7, '#3f8a55');
  }
  // the night city seen through tall windows
  function cityWindows(p, x0, x1, y0, y1, seed) {
    const g = p.g, r = G.rng(seed), w = x1 - x0, h = y1 - y0;
    p.rect(x0 - 3, y0 - 3, w + 6, h + 6, '#3a4058');
    g.drawImage(G.ditherGrad(w, h, [[0, '#090d1c'], [0.55, '#14233f'], [1, '#2a3a5a']]), x0, y0);
    for (let i = 0; i < 30; i++) p.px(x0 + r() * w, y0 + r() * h * 0.5, r() < 0.3 ? '#ffe9a8' : '#9fb4e0');
    G.disc(g, x1 - 40, y0 + 18, 7, '#f3e7c2'); G.disc(g, x1 - 42, y0 + 16, 2, '#e2d3a6');
    for (let x = x0; x < x1;) {
      const bw = 12 + Math.floor(r() * 22), bh = 24 + Math.floor(r() * (h - 30)), col = r() < 0.5 ? '#0e1626' : '#121c30';
      p.rect(x, y1 - bh, Math.min(bw, x1 - x), bh, col);
      for (let wy = y1 - bh + 3; wy < y1 - 2; wy += 4) for (let wx = x + 2; wx < Math.min(x + bw, x1) - 2; wx += 3) if (r() < 0.22) p.px(wx, wy, r() < 0.6 ? '#ffd97a' : '#cfe0ff');
      x += bw + 1;
    }
    for (let x = x0 + 64; x < x1 - 8; x += 68) p.rect(x, y0, 3, h, '#3a4058');
    p.rect(x0 - 4, y1 + 3, w + 8, 3, '#4a5068').rect(x0 - 4, y1 + 3, w + 8, 1, '#6a7088');
  }
  // classroom / office walls, floors and pendant lamps
  function room(p, w, wall, wall2, floor, floor2) {
    p.rect(0, 0, w, GY, wall).rect(0, 0, w, 12, wall2).rect(0, 12, w, 1, K);
    p.rect(0, GY, w, H - GY, floor).rect(0, GY, w, 1, G.mix(floor, '#ffffff', 0.2));
    for (let y = GY + 5, i = 0; y < H; y += 5, i++) { p.rect(0, y, w, 1, floor2); for (let x = (i * 37) % 60; x < w; x += 60) p.rect(x, y - 4, 1, 4, floor2); }
  }
  function pendant(p, x, lights, col, shade) {
    p.rect(x, 13, 1, 14, FRAME).rect(x - 6, 27, 13, 4, shade || '#3a3346').rect(x - 6, 27, 13, 1, G.mix(shade || '#3a3346', '#ffffff', 0.2)).rect(x - 3, 31, 7, 2, '#fff3c4');
    lights.push({ x: x + 0.5, y: 38, r: 100, col: col || '#ffe2b0', a: 1, glow: 0.24, flick: 1 });
  }

  // ---------- the places ----------
  const PLACES = {
    town: {
      name: '풀잎 마을', w: R.town.w, sky: true, ambient: '#9aa2d0', start: 80,
      ground: (x) => GY - Math.round(bump(x, 1000, 58, 9) + bump(x, 1372, 52, 6) + bump(x, 36, 40, 5)),
      doors: [
        { id: 'school', x: 290, to: 'school', toAt: 'out', label: '들어가기' },
        { id: 'office', x: 675, to: 'office', toAt: 'out', label: '들어가기' },
        { id: 'starbox', x: 829, to: 'starbox', toAt: 'out', label: '들어가기' },
        { id: 'map', x: 1110, to: 'map', label: '모험 떠나기' },
      ],
      tables: tablesOf('town'),
      npcs: [{ kind: 'snail', alt: 'sheep', x: 548, face: -1, lines: ['안녕! 여기는 풀잎 마을이야.', '분수 왼쪽은 얼라 비즈니스 스쿨, 오른쪽은 퍼스트파이브랑 스타박스야.', '모험을 떠나고 싶으면 동쪽 끝 터미널로 가 봐.'] }],
      signs: [
        { x: 96, y: 149, text: '풀잎 마을', col: '#f4ede0' },
        { x: 290, y: 129, text: '얼라 비즈니스 스쿨', col: '#ffd97a' },
        { x: 675, y: 122, ascii: 'FIRST FIVE', col: '#ffd97a' },
        { x: 675, y: 132, text: '퍼스트파이브', col: '#f4ede0' },
        { x: 878, y: 62, text: '스타박스', col: '#f4ead2' },
        { x: 878, y: 77, ascii: 'STARBOX', col: '#c9e8d4', tiny: 1 },
        { x: 1110, y: 123, text: '모험', col: '#7dff9a' },
      ],
      paint(lights) {
        const P = this, p = G.pix(P.w, H), g = p.g;
        // ground: the Source Tree's soil, with grassy mounds on top
        for (let tx = 0; tx < P.w / T; tx++) for (let ty = 0; ty < 2; ty++) G.drawSolid(g, 1, tx * T, GY + ty * T, tx, ty + 40, { u: ty > 0, d: true, l: true, r: true });
        for (let x = 0; x < P.w; x++) {
          const top = P.ground(x);
          if (top >= GY) continue;
          p.rect(x, top, 1, GY - top + 5, '#2b2440').rect(x, top, 1, 4, '#2f7a52').rect(x, top, 1, 3, '#5fb86f');
          if (G.hash(x, 3, 5) < 0.55) p.px(x, top, '#a6e88f');
        }
        const paved = [[176, 408], [420, 584], [586, 764], [772, 976], [1076, 1144]];
        for (let tx = 0; tx < P.w / T; tx++) {
          const x = tx * T;
          if (paved.some(([a, b]) => x + T > a && x < b) || P.ground(x + 8) < GY) continue;
          G.drawDecor(g, 1, x, GY - T, tx, 41);
        }
        paved.forEach(([a, b]) => cobbles(p, a, b));
        fence(p, 0, 70, GY); fence(p, 1384, 1440, GY);
        // village sign
        p.rect(70, 148, 3, 36, '#5a3a2a').rect(119, 148, 3, 36, '#5a3a2a');
        p.rect(64, 144, 64, 20, '#c9955c').rect(65, 145, 62, 18, '#6a4a34').rect(65, 145, 62, 1, '#8a6248');
        // ---- 얼라 비즈니스 스쿨 (room id: school) ----
        const wall = '#4a3a52', mortar = '#3e3046', roof = '#24485a';
        p.rect(270, 44, 40, 52, wall).rect(270, 44, 1, 52, '#6a5872');
        for (let j = 0; j < 20; j++) p.rect(266 + j, 43 - j, 48 - j * 2, 1, j % 4 === 3 ? '#1c3a4a' : roof);
        p.rect(289, 8, 1, 17, FRAME).rect(290, 9, 7, 2, '#7fd08a').rect(290, 11, 5, 2, '#7fd08a').rect(290, 13, 3, 1, '#3f8a55');
        G.disc(g, 290, 62, 9, FRAME); G.disc(g, 290, 62, 7, '#f4ede0');
        p.rect(290, 56, 1, 6, K).rect(290, 62, 4, 1, K).px(290, 62, C.accent);
        p.rect(180, 96, 220, 88, wall);
        for (let y = 98, i = 0; y < GY; y += 6, i++) { p.rect(180, y, 220, 1, mortar); for (let x = 180 + (i % 2) * 6; x < 400; x += 12) p.rect(x, y, 1, 6, mortar); }
        p.rect(180, 96, 1, 88, '#6a5872').rect(399, 96, 1, 88, FRAME).rect(176, 174, 228, 10, '#3a3046').rect(176, 174, 228, 1, '#5a4a62');
        for (let j = 0; j < 22; j++) p.rect(170 + j, 95 - j, 240 - j * 2, 1, j % 4 === 3 ? '#1c3a4a' : roof);
        p.rect(170, 95, 240, 1, '#3a6a7a').rect(170, 96, 240, 2, '#1c2a3a');
        [196, 226, 336, 366].forEach((x, i) => windowAt(p, x, 146, 18, 20, i !== 2, lights));
        [196, 226, 256, 306, 336, 366].forEach((x, i) => windowAt(p, x, 106, 18, 18, i !== 1 && i !== 4, lights));
        p.rect(226, 126, 128, 18, '#c9955c').rect(227, 127, 126, 16, '#2a2338');   // the name plaque, wide enough for 얼라 비즈니스 스쿨
        p.rect(268, 144, 44, 4, '#6a5872');
        doorAt(p, 277, 150, 26, 34, '#6a4a34', lights);
        p.rect(289, 150, 2, 34, FRAME);
        p.rect(270, 181, 40, 3, '#5a5568').rect(270, 181, 40, 1, '#8d8798');
        // ---- plaza: bench + fountain ----
        p.rect(444, 175, 26, 3, '#8a6248').rect(444, 175, 26, 1, '#c9955c').rect(446, 178, 2, 6, '#5a3a2a').rect(466, 178, 2, 6, '#5a3a2a').rect(444, 166, 26, 2, '#6a4a34').rect(446, 168, 2, 7, '#5a3a2a').rect(466, 168, 2, 7, '#5a3a2a');
        p.rect(478, 172, 56, 12, '#6b6578').rect(478, 172, 56, 2, '#8d8798').rect(480, 174, 52, 3, '#58f0c8').rect(478, 182, 56, 2, '#4a4458');
        p.rect(503, 150, 6, 22, '#6b6578').rect(503, 150, 2, 22, '#8d8798');
        p.rect(494, 148, 24, 4, '#6b6578').rect(494, 148, 24, 1, '#8d8798').rect(496, 152, 20, 1, '#4a4458');
        // ---- FIRST FIVE: a glassy office block ----
        const ow = '#2e3446', band = '#3a4058';
        p.rect(594, 40, 162, 144, ow).rect(594, 40, 1, 144, '#4a5068').rect(755, 40, 1, 144, FRAME);
        p.rect(590, 36, 170, 5, band).rect(590, 36, 170, 1, '#6a7088');
        [606, 626, 728].forEach((x, i) => p.ell(x, 34, 6 + i, 4, '#3f8a55').ell(x - 2, 32, 3, 2, '#5fb86f'));     // a little roof garden
        p.rect(744, 22, 1, 14, FRAME).px(744, 21, '#ff5d5d');
        for (const fy of [50, 72, 94]) {
          p.rect(594, fy - 4, 162, 1, band);
          for (let x = 602, i = 0; x < 748; x += 16, i++) {
            const hsh = G.hash(i, fy, 9), col = hsh < 0.4 ? '#d8e6ff' : hsh < 0.6 ? LIT : '#1a2238';
            p.rect(x - 1, fy - 1, 14, 16, FRAME).rect(x, fy, 12, 14, col).rect(x + 6, fy, 1, 14, FRAME);
            if (hsh < 0.6) p.rect(x, fy + 11, 12, 3, hsh < 0.4 ? '#a8bce0' : LITLO);
          }
        }
        p.rect(604, 119, 142, 27, '#c9955c').rect(605, 120, 140, 25, '#1b1226');
        p.rect(594, 148, 162, 2, band);
        [[600, 652], [698, 750]].forEach(([a, b]) => {
          p.rect(a - 1, 153, b - a + 2, 28, FRAME).rect(a, 154, b - a, 26, '#ffe9c0').rect(a, 174, b - a, 6, '#e8c890');
          for (let x = a + 12; x < b; x += 13) p.rect(x, 154, 1, 26, FRAME);
          lights.push({ x: (a + b) / 2, y: 166, r: 44, col: '#ffe2b0', a: 0.9, glow: 0.2 });
        });
        p.rect(608, 168, 8, 6, '#3f8a55').rect(626, 166, 10, 3, '#3a3346').rect(712, 168, 12, 2, '#6a4a34').rect(734, 164, 8, 10, '#3f8a55');
        p.rect(656, 148, 38, 4, band).rect(659, 152, 32, 32, FRAME).rect(661, 154, 13, 30, '#cfe8ff').rect(676, 154, 13, 30, '#cfe8ff');
        p.rect(661, 154, 2, 30, '#ffffff').rect(673, 165, 1, 4, FRAME).rect(676, 165, 1, 4, FRAME);
        lights.push({ x: 675, y: 166, r: 40, col: '#e0f0ff', a: 0.8, glow: 0.2 });
        // ---- 스타박스: a flagship coffee house. green fascia, backlit badge, double-height glass ----
        const sx0 = 788, sx1 = 938, top = 50;
        p.rect(sx0 - 2, top - 2, sx1 - sx0 + 4, 2, '#e8dcc4');
        p.rect(sx0, top, sx1 - sx0, 8, '#d8ccb0').rect(sx0, top, sx1 - sx0, 1, '#f4ead2').rect(sx0, top + 7, sx1 - sx0, 1, '#a8987c');   // stone cornice
        for (let x = sx0 + 4; x < sx1 - 2; x += 6) p.rect(x, top + 3, 2, 2, '#bcae90');
        p.rect(sx0, top + 8, sx1 - sx0, 28, SB.deep).rect(sx0, top + 8, sx1 - sx0, 1, SB.green).rect(sx0, top + 34, sx1 - sx0, 2, SB.dark);
        p.rect(sx0 + 30, top + 11, sx1 - sx0 - 34, 1, SB.brass).rect(sx0 + 30, top + 31, sx1 - sx0 - 34, 1, SB.brass);
        emblem(p, 807, top + 22, 12);
        lights.push({ x: 807, y: top + 22, r: 44, col: '#c9f0d8', a: 0.9, glow: 0.35 }, { x: 872, y: top + 22, r: 64, col: '#fff1d0', a: 0.6, glow: 0.18 });
        // double-height glass: the warm room inside shows through (upper wall, pendants, menu panels, shelves, the bar)
        const g0 = top + 36, bays = [[sx0 + 4, 852], [858, sx1 - 4]];
        p.rect(sx0, g0, sx1 - sx0, GY - g0, SB.walnut);
        bays.forEach(([a, b], k) => {
          p.rect(a - 1, g0 + 1, b - a + 2, 180 - g0 - 1, SB.brass);
          p.rect(a, g0 + 2, b - a, 36, '#1d4f3b').rect(a, g0 + 2, b - a, 3, '#163e2f');                    // upper wall, deep green
          p.rect(a, g0 + 38, b - a, 180 - g0 - 38, '#f0c890').rect(a, g0 + 38, b - a, 2, '#ffe2b0');       // lit lower wall
          for (let x = a + 7; x < b - 4; x += 16) { p.rect(x, g0 + 2, 1, 12, '#0e2a1f').rect(x - 3, g0 + 14, 7, 3, SB.brass).rect(x - 1, g0 + 17, 3, 1, '#fff8e0'); lights.push({ x, y: g0 + 20, r: 22, col: '#ffd6a0', a: 0.6, glow: 0.25 }); }
          if (k) { for (let x = a + 4; x < b - 8; x += 20) p.rect(x, g0 + 44, 16, 10, '#123a2e').rect(x + 2, g0 + 46, 9, 1, SB.cream).rect(x + 2, g0 + 49, 11, 1, SB.cream).rect(x + 2, g0 + 52, 7, 1, '#c6f2a8'); }
          else for (let x = a + 3; x < b - 3; x += 5) p.rect(x, g0 + 48, 3, 5, ((x >> 1) % 3) ? SB.cream : SB.green).rect(a, g0 + 53, b - a, 1, SB.walnut);
          p.rect(a, 162, b - a, 3, '#ece6da').rect(a, 165, b - a, 15, '#6a4a30');                         // the bar seen from the street
          for (let x = a + 2; x < b; x += 4) p.rect(x, 166, 1, 14, '#5a3a24');
          p.rect(a, g0 + 38, b - a, 1, SB.brass);                                                          // transom
          p.line(a + 5, g0 + 12, a + 11, g0 + 6, '#3a7a5c'); p.line(a + 8, g0 + 12, a + 14, g0 + 6, '#3a7a5c');   // a soft glint on the glass
          lights.push({ x: (a + b) / 2, y: 150, r: 70, col: '#ffcf90', a: 1, glow: 0.3 });
        });
        p.rect(864, 150, 9, 12, '#3a3a40').rect(865, 151, 7, 4, '#c5cbdb').px(868, 158, SB.green);      // a machine glimpsed through the glass
        [878, 888, 904].forEach((x) => sbCup(p, x, 162));
        p.rect(852, g0, 6, GY - g0, SB.walnut).rect(852, g0, 1, GY - g0, '#5a3a24');
        p.rect(sx0, g0, 4, GY - g0, SB.walnut2).rect(sx1 - 4, g0, 4, GY - g0, SB.walnut2);
        [sx0 + 2, 855, sx1 - 2].forEach((x) => { p.rect(x - 2, 126, 4, 2, SB.brass).rect(x - 1, 128, 2, 3, SB.brassHi); lights.push({ x, y: 130, r: 26, col: '#ffe2b0', a: 0.8, glow: 0.3 }); });   // brass sconces
        // the door (x 829) in the left bay: walnut frame, glass, brass pull
        p.rect(818, 146, 22, 38, SB.walnut).rect(820, 148, 18, 36, '#ffe9c0').rect(820, 148, 18, 2, '#fff8e0').rect(828, 148, 2, 36, SB.walnut);
        p.rect(825, 160, 1, 10, SB.brass).rect(832, 160, 1, 10, SB.brass);
        emblem(p, 829, 140, 3);
        p.rect(sx0 - 2, 180, sx1 - sx0 + 4, 4, '#8d8798').rect(sx0 - 2, 180, sx1 - sx0 + 4, 1, '#c3bccd');
        // boxwood planters, a parasol table on the pavement, warm light spilling out
        [784, 942].forEach((x) => p.rect(x - 6, 170, 12, 14, '#3a3a40').rect(x - 6, 170, 12, 1, '#6b6578').ell(x, 166, 7, 6, '#1f5a3a').ell(x - 2, 164, 3, 3, '#3f8a55'));
        p.rect(960, 126, 1, 46, '#d8ccb0');
        for (let j = 0; j < 8; j++) p.rect(959 - j * 2, 124 + j, 3 + j * 4, 1, j % 2 ? SB.green : SB.deep);
        p.rect(944, 132, 33, 2, SB.cream);
        p.rect(952, 170, 18, 2, '#e8dcc4').rect(960, 172, 2, 12, '#2a2a2e').rect(956, 182, 10, 2, '#2a2a2e');
        sbCup(p, 954, 170);
        lights.push({ x: 863, y: 186, r: 80, col: '#ffcf90', a: 0.8, glow: 0.12 });
        // ---- adventure terminal ----
        p.rect(1090, 124, 2, 60, FRAME).rect(1128, 124, 2, 60, FRAME);
        p.rect(1084, 118, 52, 18, '#c9955c').rect(1085, 119, 50, 16, '#0b1410');
        p.draw(S.gate, 1095, GY - 40);
        // ---- a house, trees, lamps ----
        house(p, 1226, 76, 44, '#2e3a4a', '#4a3a52', lights, 9);
        [24, 994, 1046, 1196, 1414].forEach((x) => tree(p, x, P.ground(x)));
        [150, 424, 574, 774, 1066, 1166, 1336].forEach((x) => lamp(p, x, P.ground(x), lights));
        return [p.c];
      },
      live(g, ug, cx, t) {
        // fountain: two arcs of falling water
        for (let i = 0; i < 14; i++) {
          const u = (t * 0.9 + i / 14) % 1, side = i % 2 ? 1 : -1, x = 506 + side * (6 + u * 16) - cx, y = 147 + -10 * u + 32 * u * u;
          g.fillStyle = u < 0.5 ? '#d2fff2' : '#58f0c8'; g.fillRect(Math.round(x), Math.round(y), 1, 2);
        }
        g.fillStyle = '#d2fff2'; g.fillRect(505 - cx, 140 + Math.round(Math.sin(t * 9)), 2, 8);
        G.light(506 - cx, 160, 50, '#58f0c8', 0.5, 0.2);
        // the terminal screen
        const sx = 1099 - cx, sy = GY - 30;
        G.text(g, '$ git', sx, sy + 1, '#7dff9a', { tiny: true });
        G.text(g, 'log', sx, sy + 8, '#7dff9a', { tiny: true });
        if (((t * 2) | 0) % 2) { g.fillStyle = '#7dff9a'; g.fillRect(sx + 14, sy + 8, 3, 5); }
        G.light(1110 - cx, GY - 22, 60, '#3cff7a', 0.8, 0.3);
      },
    },

    school: {
      name: '얼라 비즈니스 스쿨', w: R.school.w, ambient: '#9a8fb4', start: 46,
      ground: () => GY,
      doors: [{ id: 'out', x: 30, to: 'town', toAt: 'school', label: '나가기' }],
      tables: tablesOf('school'),
      board: { x: 376, y: 44, w: 122, h: 68, frame: [372, 40, 130, 76] },   // the chalkboard: screen shares are drawn inside it, and a click on the frame opens the big view
      npcs: [{ kind: 'owl', alt: 'mushroom', role: '선생님', x: 402, face: -1, lines: ['어서 와! 얼라 비즈니스 스쿨에 온 걸 환영해.', '빈 의자 앞에서 아래 키를 누르면 앉을 수 있어.', "오늘 수업은 '친구 사귀기'란다. 열두 자리가 다 찼으면 좋겠구나."] }],
      signs: [
        { x: 384, y: 52, text: '오늘의 수업', col: '#f4ede0', left: 1 },
        { x: 384, y: 68, text: '친구 사귀기', col: '#ffd97a', left: 1 },
        { x: 384, y: 88, ascii: '1 + 1 = 2', col: '#c6f2a8', left: 1 },
      ],
      paint(lights) {
        const P = this, p = G.pix(P.w, H), f = G.pix(P.w, H), g = p.g;
        room(p, P.w, '#28304a', '#1c2236', '#5a3a2a', '#4a2e22');
        for (let x = 0; x < P.w; x += 32) p.rect(x, 13, 1, 125, '#2c3552');
        p.rect(0, 138, P.w, 46, '#4a3226').rect(0, 138, P.w, 3, '#6a4a34').rect(0, 141, P.w, 1, '#3a2a22');
        for (let x = 12; x < P.w; x += 24) p.rect(x, 142, 1, 42, '#3a2a22');
        // window onto the night
        p.rect(104, 34, 60, 74, '#6a4a34');
        g.drawImage(G.ditherGrad(52, 66, [[0, '#090d1c'], [0.7, '#14233f'], [1, '#22385a']]), 108, 38);
        G.disc(g, 146, 54, 7, '#f3e7c2'); G.disc(g, 144, 52, 2, '#e2d3a6');
        const r = G.rng(14); for (let i = 0; i < 14; i++) p.px(110 + r() * 48, 40 + r() * 50, r() < 0.3 ? '#ffe9a8' : '#9fb4e0');
        p.rect(133, 38, 3, 66, '#6a4a34').rect(108, 70, 52, 3, '#6a4a34').rect(100, 108, 68, 4, '#8a6248');
        lights.push({ x: 134, y: 70, r: 70, col: '#cfe0ff', a: 0.6, glow: 0.12 });
        p.rect(206, 40, 120, 22, '#2a5c4a').rect(207, 41, 118, 20, '#1f4a3a');     // a banner of leaf drawings
        for (let i = 0; i < 9; i++) p.ell(216 + i * 13, 51, 3, 5, ['#7fd08a', '#a6e88f', '#f2c14e', '#ff9db5'][i % 4]).rect(216 + i * 13, 50, 1, 7, '#3f8a55');
        // chalkboard at the front of the class
        p.rect(372, 40, 130, 76, '#6a4a34').rect(376, 44, 122, 68, '#1f4a3a').rect(376, 44, 122, 1, '#2a5c4a');
        for (let i = 0; i < 34; i++) p.px(378 + r() * 118, 46 + r() * 64, '#2a5a48');
        p.rect(372, 116, 130, 3, '#8a6248').rect(390, 114, 6, 2, '#f4ede0').rect(402, 114, 4, 2, '#ff9db5').rect(470, 114, 8, 2, '#c9bfd8');
        p.rect(478, 86, 1, 14, '#e8f0e0').rect(472, 84, 6, 1, '#e8f0e0').rect(470, 83, 3, 1, '#e8f0e0').rect(479, 82, 6, 1, '#e8f0e0').rect(484, 81, 3, 1, '#e8f0e0');
        p.rect(470, 100, 18, 1, '#e8f0e0').rect(472, 101, 14, 4, '#c9bfd8');
        // clock + bookshelf + plant
        G.disc(g, 190, 88, 9, FRAME); G.disc(g, 190, 88, 7, '#f4ede0'); p.rect(190, 83, 1, 5, K).rect(190, 88, 4, 1, K);
        p.rect(52, 120, 34, 64, '#5a3a2a').rect(54, 122, 30, 60, '#2a1c18');
        const books = ['#e0566a', '#7cc4ff', '#f2c14e', '#7fd08a', '#b79cff', '#f4ede0', '#ff9db5'];
        for (let s = 0; s < 3; s++) { p.rect(54, 140 + s * 20, 30, 2, '#5a3a2a'); for (let x = 55, i = s; x < 82; i++) { const bw = 2 + ((i * 7) % 3), bh = 12 + ((i * 5) % 6); p.rect(x, 140 + s * 20 - bh, bw, bh, books[i % books.length]); x += bw + 1; } }
        plant(p, 496, GY, true);
        doorAt(p, 18, 146, 24, 38, '#6a4a34', lights);
        // six desks for two: back row desks + chairs behind the critters, front row in front of them
        P.tables.filter((tb) => tb.kind === 'pair').forEach((tb, i) => {
          const [b, fr] = tb.seats, X = b.x;
          p.rect(X + 6, 157, 14, 3, '#c9955c').rect(X + 6, 157, 14, 1, '#e8b878').rect(X + 7, 160, 2, 12, '#5a3a2a').rect(X + 17, 160, 2, 12, '#5a3a2a');
          f.rect(X + 20, 171, 14, 3, '#c9955c').rect(X + 20, 171, 14, 1, '#e8b878').rect(X + 21, 174, 2, 10, '#5a3a2a').rect(X + 31, 174, 2, 10, '#5a3a2a');
          p.rect(X + 13, 154, 5, 3, books[i % 7]).rect(X + 27, 168, 4, 3, books[(i + 3) % 7]);
          chair(p, b, '#8a6248', 1); chair(f, fr, '#8a6248', 1);
        });
        // the lectern (seat 30, shared/world/seats.ts): whoever sits here teaches. The podium is in the front layer, so the teacher shows from the chest up
        P.tables.filter((tb) => tb.kind === 'lectern').forEach((tb) => {
          const X = tb.x;
          p.rect(X - 16, 176, 32, 8, '#3a2418').rect(X - 14, 174, 28, 2, '#4a3020');                                  // a low platform
          f.rect(X - 14, 167, 28, 9, '#6a4a34').rect(X - 12, 169, 24, 6, '#5a3a2a').rect(X - 12, 169, 24, 1, '#3a2418');   // the podium front: the teacher shows above it
          f.rect(X - 17, 164, 34, 3, '#c9955c').rect(X - 17, 164, 34, 1, '#e8b878').rect(X - 17, 167, 34, 1, '#8a6248');   // its top
          f.rect(X - 3, 170, 6, 3, '#c9955c').px(X, 171, '#2a5c4a');                                                    // a little plaque
        });
        [140, 250, 360, 450].forEach((x) => pendant(p, x, lights));
        return [p.c, f.c];
      },
    },

    office: {
      name: '퍼스트파이브', w: R.office.w, ambient: '#9a9cc4', start: 46,
      ground: () => GY,
      doors: [{ id: 'out', x: 30, to: 'town', toAt: 'office', label: '나가기' }],
      tables: tablesOf('office'),
      npcs: [{ kind: 'sheep', alt: 'snail', role: '매니저', x: 112, face: 1, lines: ['퍼스트파이브에 오신 걸 환영해요!', '회의 테이블은 두 개, 한 테이블에 여섯 명씩 앉을 수 있어요.', '창가 스탠딩 데스크는 누구나 자유롭게 쓰세요.'] }],
      signs: [
        { x: 98, y: 42, ascii: 'FIRST FIVE', col: '#ffd97a' },
        { x: 98, y: 52, text: '퍼스트파이브', col: '#f4ede0' },
        { x: 212, y: 120, text: '회의실 A', col: '#c6f2a8' },
        { x: 358, y: 120, text: '회의실 B', col: '#c6f2a8' },
      ],
      paint(lights) {
        const P = this, p = G.pix(P.w, H), f = G.pix(P.w, H);
        room(p, P.w, '#252a3a', '#1a1e2a', '#4a3a40', '#3e3036');
        cityWindows(p, 154, 696, 22, 112, 21);
        lights.push({ x: 420, y: 60, r: 220, col: '#9fb4e0', a: 0.35, glow: 0.05 });
        p.rect(0, 118, P.w, 66, '#2a2f40').rect(0, 118, P.w, 2, '#3a4058').rect(0, 180, P.w, 4, '#1e2230');
        // the name on the wall by the door
        p.rect(52, 36, 92, 32, '#c9955c').rect(53, 37, 90, 30, '#1b1226');
        lights.push({ x: 98, y: 52, r: 70, col: '#ffd97a', a: 0.7, glow: 0.22 });
        // reception
        p.rect(70, 158, 28, 26, '#c9955c').rect(70, 158, 28, 2, '#e8b878').rect(72, 162, 24, 22, '#8a6248');
        p.rect(74, 152, 8, 6, '#c5cbdb').rect(75, 153, 6, 4, '#7cc4ff').rect(88, 154, 6, 4, '#f4ede0');
        // meeting tables: back chairs here, the table and front chairs in the front layer
        P.tables.forEach((tb) => {
          const L = tb.x;
          p.rect(L - 6, 124, 96, 14, '#1e2230').rect(L - 6, 124, 96, 1, '#3a4058');      // glass partition rail with the room name
          tb.seats.forEach((s) => chair(s.back ? p : f, s, '#3f8a55'));
          f.rect(L, 166, 84, 3, '#c9955c').rect(L, 166, 84, 1, '#e8b878').rect(L + 2, 169, 80, 3, '#8a6248').rect(L + 4, 172, 3, 12, '#5a3a2a').rect(L + 77, 172, 3, 12, '#5a3a2a');
          f.rect(L + 22, 163, 3, 3, '#f4ede0').rect(L + 70, 163, 3, 3, '#7fd08a').rect(L + 46, 162, 7, 4, '#c5cbdb').rect(L + 47, 162, 5, 1, '#ffffff');
          pendant(p, L + 30, lights, '#ffe2b0', '#3f8a55'); pendant(p, L + 54, lights, '#ffe2b0', '#3f8a55');
        });
        // hot desks along the windows: standing height, monitors glowing
        p.rect(440, 150, 240, 3, '#c9955c').rect(440, 150, 240, 1, '#e8b878');
        for (let x = 446; x < 676; x += 58) p.rect(x, 153, 2, 31, '#5a3a2a');
        for (let x = 450; x < 670; x += 44) {
          p.rect(x, 130, 20, 14, '#15131c').rect(x + 1, 131, 18, 11, x % 88 < 44 ? '#7cc4ff' : '#9cf7e0').rect(x + 2, 132, 8, 1, '#ffffff').rect(x + 9, 144, 2, 6, '#15131c').rect(x + 4, 148, 12, 2, '#3a3346');
          lights.push({ x: x + 10, y: 138, r: 26, col: '#9fd4ff', a: 0.6, glow: 0.2 });
        }
        [150, 296, 420, 690].forEach((x, i) => plant(p, x, GY, i !== 1));
        doorAt(p, 18, 146, 24, 38, '#6a4a34', lights);
        return [p.c, f.c];
      },
    },

    starbox: {
      name: '스타박스', w: R.starbox.w, ambient: '#a89a9c', start: 46,
      ground: () => GY,
      doors: [{ id: 'out', x: 30, to: 'town', toAt: 'starbox', label: '나가기' }],
      tables: tablesOf('starbox'),
      npcs: [{ kind: 'hedgehog', alt: 'sprout', role: '바리스타', x: 308, y: 152, face: -1, behind: 1, reach: 40, apron: 1, lines: ['어서 오세요, 스타박스예요!', '오늘의 추천은 풀잎 라떼, 진하게 한 잔 어떠세요?', '두 분 자리가 두 곳 있어요. 천천히 머물다 가세요.'] }],
      signs: [
        { x: 312, y: 26, ascii: 'STARBOX', col: '#c9e8d4', tiny: 1 },
        { x: 255, y: 36, text: '아메리카노', col: SB.cream, left: 1 }, { x: 374, y: 37, ascii: '4.5', col: SB.brassHi, right: 1 },
        { x: 255, y: 50, text: '풀잎 라떼', col: '#c6f2a8', left: 1 }, { x: 374, y: 51, ascii: '5.9', col: SB.brassHi, right: 1 },
        { x: 255, y: 64, text: '콜드 브루', col: SB.cream, left: 1 }, { x: 374, y: 65, ascii: '4.9', col: SB.brassHi, right: 1 },
        { x: 255, y: 78, text: '바닐라 크림', col: SB.cream, left: 1 }, { x: 374, y: 79, ascii: '6.1', col: SB.brassHi, right: 1 },
        { x: 288, y: 165, text: '픽업', col: SB.cream },
      ],
      paint(lights) {
        const P = this, w = P.w, p = G.pix(w, H), f = G.pix(w, H), g = p.g;
        // deep green walls, a walnut slat ceiling, walnut wainscot, a walnut plank floor
        p.rect(0, 0, w, GY, '#123a2e');
        for (let y = 18; y < 124; y += 8) p.rect(0, y, w, 1, '#103426');
        p.rect(0, 0, w, 14, SB.walnut);
        for (let x = 0; x < w; x += 4) p.rect(x, 0, 1, 14, '#2a1a10');
        p.rect(0, 14, w, 1, SB.brass).rect(0, 15, w, 1, K);
        p.rect(0, 128, 236, 56, SB.walnut2);
        for (let x = 2; x < 236; x += 4) p.rect(x, 130, 1, 54, '#3a2418');
        p.rect(0, 126, 236, 2, SB.brass).rect(0, 128, 236, 1, '#6a4a30');
        for (let x = 0, i = 0; x < w; x += 24, i++) p.rect(x, GY, 24, H - GY, i % 2 ? '#3a2418' : '#43301f');
        for (let y = GY + 6, i = 0; y < H; y += 6, i++) for (let x = (i % 2) * 12; x < w; x += 24) p.rect(x, y, 12, 1, '#2a1a10');
        p.rect(0, GY, w, 1, '#6a4a30');
        // a big window onto the night street
        cityWindows(p, 54, 200, 28, 108, 33);
        p.rect(48, 22, 158, 3, SB.walnut).rect(48, 112, 158, 4, SB.walnut).rect(48, 112, 158, 1, SB.brass);
        for (let x = 102; x < 200; x += 49) p.rect(x, 28, 2, 80, SB.brass);
        // the badge on the wall, backlit
        G.disc(g, 222, 56, 17, '#1a5a40');
        emblem(p, 222, 56, 13);
        lights.push({ x: 222, y: 56, r: 64, col: '#d8ffe8', a: 0.9, glow: 0.35 });
        // menu wall: three clean dark panels with a brass edge
        p.rect(244, 20, 136, 72, SB.brass).rect(245, 21, 134, 70, '#0e1f19');
        p.rect(245, 31, 134, 1, '#1f3a30');
        [34, 48, 62, 76].forEach((y) => p.rect(246, y + 1, 4, 6, SB.cream).rect(246, y + 3, 4, 2, '#b98a5a'));
        lights.push({ x: 312, y: 56, r: 80, col: '#fff1d0', a: 0.6, glow: 0.12 });
        // merchandise shelves: tumblers and mugs, lit from underneath
        [110, 126].forEach((y, k) => {
          p.rect(244, y, 136, 2, SB.walnut).rect(244, y + 2, 136, 1, '#fff1d0');
          for (let x = 248, i = k; x < 376; x += 11, i++) {
            const c = [SB.green, SB.cream, '#1b1b1f', SB.brass][i % 4];
            if (i % 3 === 2) p.rect(x, y - 6, 7, 6, c).rect(x + 7, y - 5, 2, 3, c).px(x + 3, y - 4, c === SB.green ? SB.cream : SB.green);   // mug
            else p.rect(x + 1, y - 11, 5, 11, c).rect(x + 1, y - 12, 5, 1, '#c5cbdb').px(x + 3, y - 7, c === SB.green ? SB.cream : SB.green);   // tumbler
          }
          lights.push({ x: 312, y: y + 4, r: 40, col: '#ffe2b0', a: 0.5, glow: 0.12 });
        });
        // cream tile backsplash behind the bar
        p.rect(236, 130, w - 236, 28, '#e8dcc4');
        for (let y = 130; y < 158; y += 4) p.rect(236, y, w - 236, 1, '#cdbfa4');
        for (let y = 130, i = 0; y < 158; y += 4, i++) for (let x = 236 + (i % 2) * 4; x < w; x += 8) p.rect(x, y, 1, 4, '#cdbfa4');
        // the long walnut bar (front layer): pastry case, pickup spot, the espresso machine row
        f.rect(232, 156, w - 232, 4, '#ece6da').rect(232, 156, w - 232, 1, '#ffffff').rect(232, 159, w - 232, 1, SB.brass);
        f.rect(234, 160, w - 234, 24, '#5a3a24');
        for (let x = 236; x < w; x += 4) f.rect(x, 162, 1, 22, SB.walnut2);
        f.rect(234, 160, w - 234, 2, '#ffd6a0').rect(234, 178, w - 234, 1, SB.brass).rect(234, 179, w - 234, 1, SB.brassHi);   // under-counter light, brass foot rail
        for (let x = 250; x < w; x += 46) lights.push({ x, y: 166, r: 34, col: '#ffd6a0', a: 0.7, glow: 0.18 });
        f.rect(272, 163, 32, 15, SB.brass).rect(273, 164, 30, 13, SB.green);                     // the pickup plate
        f.rect(238, 136, 40, 20, SB.brass).rect(239, 137, 38, 18, '#fff1d0').rect(239, 145, 38, 1, '#d8ccb0');        // pastry case
        [[241, '#d8a050'], [248, '#8a5a3a'], [255, '#d8a050'], [262, '#f0b0c0'], [269, '#8a5a3a']].forEach(([x, c], i) => f.rect(x, 141, 5, 3, c).rect(x + 1, 140, 3, 1, c).rect(x, 151, 5, 3, ['#f0b0c0', '#e8dcc4', '#c98a4a', '#e8dcc4', '#d8a050'][i]).rect(x, 151, 5, 1, '#ffffff'));
        lights.push({ x: 258, y: 146, r: 44, col: '#fff1d0', a: 0.9, glow: 0.3 });
        f.rect(278, 150, 18, 6, '#e8dcc4').rect(278, 150, 18, 1, '#ffffff');      // pickup shelf
        sbCup(f, 280, 150); sbCup(f, 288, 150);
        f.rect(318, 132, 62, 4, '#c5cbdb').rect(318, 136, 62, 16, '#1b1b1f').rect(318, 136, 62, 1, '#3a3a40').rect(318, 148, 62, 4, SB.green);   // espresso machine row
        for (let x = 324; x < 376; x += 18) f.rect(x, 140, 8, 3, '#8a92a8').rect(x + 3, 143, 2, 4, '#c5cbdb').rect(x + 1, 152, 6, 4, SB.cream).px(x + 6, 138, '#7dff9a');
        emblem(f, 349, 142, 3);
        [324, 340, 356].forEach((x) => f.rect(x, 128, 6, 4, SB.cream).rect(x, 128, 6, 1, '#ffffff'));
        // tables for two: marble tops, brass rims, green leather chairs on walnut legs
        P.tables.forEach((tb) => {
          const tx = tb.x;
          p.rect(tx - 12, 159, 24, 3, '#ece6da').rect(tx - 12, 159, 24, 1, '#ffffff').rect(tx - 12, 162, 24, 1, SB.brass).px(tx - 6, 160, '#b8b0a4').px(tx - 5, 161, '#b8b0a4').px(tx + 4, 160, '#b8b0a4');
          p.rect(tx - 1, 163, 2, 19, '#1b1b1f').rect(tx - 7, 182, 14, 2, SB.brass);
          tb.seats.forEach((s) => {
            const rear = s.face > 0 ? s.x - 7 : s.x + 5;
            p.rect(rear, s.y - 13, 2, 16, SB.walnut).rect(rear - (s.face > 0 ? 0 : 1), s.y - 14, 3, 1, SB.brass);
            p.rect(rear + (s.face > 0 ? 2 : -2), s.y - 11, 2, 9, SB.green);
            p.rect(s.x - 6, s.y, 12, 3, SB.green).rect(s.x - 6, s.y, 12, 1, '#3a8a64');
            p.rect(s.x - 5, s.y + 3, 2, GY - s.y - 3, SB.walnut).rect(s.x + 3, s.y + 3, 2, GY - s.y - 3, SB.walnut);
          });
          sbCup(p, tx - 7, 159); sbCup(p, tx + 3, 159);
        });
        plant(p, 216, GY, true);
        // the door: walnut and brass
        p.rect(16, 143, 28, 41, SB.walnut).rect(18, 146, 24, 38, '#ffe9c0').rect(29, 146, 2, 38, SB.walnut).rect(24, 160, 1, 10, SB.brass).rect(35, 160, 1, 10, SB.brass);
        lights.push({ x: 30, y: 160, r: 30, col: '#ffe2b0', a: 0.7, glow: 0.18 });
        // brass dome pendants over the tables and the bar
        const dome = (x) => { p.rect(x, 15, 1, 16, '#1b1b1f').rect(x - 5, 31, 11, 2, SB.brass).rect(x - 6, 33, 13, 3, SB.brass).rect(x - 6, 33, 13, 1, SB.brassHi).rect(x - 2, 36, 5, 1, '#fff8e0'); lights.push({ x: x + 0.5, y: 42, r: 96, col: '#ffd6a0', a: 1, glow: 0.28, flick: 1 }); };
        [96, 176, 276, 344].forEach(dome);
        return [p.c, f.c];
      },
      live(g, ug, cx, t) {
        [89, 99, 169, 179, 281, 289].forEach((x, k) => {
          for (let i = 0; i < 2; i++) { const u = (t * 0.4 + i / 2 + k * 0.17) % 1; g.fillStyle = G.rgba('#ffffff', 0.35 * (1 - u)); g.fillRect(Math.round(x - cx + Math.sin(u * 6 + i + k) * 2), Math.round((k > 3 ? 139 : 148) - u * 12), 1, 2); }
        });
      },
    },
  };

  // ---------- a walking critter's pose (the same body language the stage hero uses) ----------
  function pose(o, a) {
    if (a.sit) { o.sit = true; o.blink = a.blinkT < 0; return o; }
    if (!a.ground) { o.armL = o.armR = -2; o.legs = a.vy < 0 ? [2, 2, 2, 2] : [2, 1, 1, 2]; o.eyeY = a.vy < 0 ? -1 : 1; return o; }
    if (Math.abs(a.vx) > 20) {
      const f = ((a.runT * 11) | 0) % 4;
      o.legs = f === 0 ? [2, 1, 2, 1] : f === 2 ? [1, 2, 1, 2] : [2, 2, 2, 2];
      o.lift = f % 2 ? 0 : -1; o.armL = f === 0 ? -1 : 0; o.armR = f === 2 ? -1 : 0;
      return o;
    }
    if (Math.sin(a.t * 2.6) > 0.55) { o.lift = 1; o.legs = [1, 1, 1, 1]; }
    o.blink = a.blinkT < 0;
    return o;
  }

  // =====================================================================
  // a place you can walk around in
  // =====================================================================
  function Place(id, at) {
    const P = PLACES[id];
    if (!P.layers) { P.lights = []; P.layers = P.paint(P.lights); }
    const door = P.doors.find((d) => d.id === at);
    const h = { x: door ? door.x + (P.sky ? 0 : 16) : P.start, y: 0, vx: 0, vy: 0, face: 1, ground: true, t: 0, runT: 0, blinkT: 2, sx: 1, sy: 1, sit: null, dashT: 0, dashCd: 0, canDash: true, ddx: 1, ddy: 0, ghosts: [], ghostT: 0 };
    h.y = P.ground(h.x);
    const npcs = P.npcs.map((n) => ({ ...n, kind: n.kind === SV().hero ? n.alt : n.kind, y: n.y || P.ground(n.x), t: G.rand(3), blinkT: G.rand(1, 3), ground: true, vx: 0, runT: 0 }));
    const camOf = () => G.clamp(h.x - W / 2, 0, P.w - W);
    let t = 0, cx = camOf(), talk = null, nDoor = null, nSeat = null, nNpc = null, nBoard = false;
    G.seated = null;
    G.presence.enter(id);   // other people in this place: the net bridge (client/1-endpoints/net/presence.ts)
    const stand = () => { h.sit = null; G.seated = null; h.y = P.ground(h.x); h.sx = 0.85; h.sy = 1.2; A.sfx('land'); };
    const enter = (d) => {
      A.sfx('uiOk');
      if (d.to === 'map') {
        if (SV().seen.intro) G.go(() => G.Scenes.map());
        else G.go(() => G.CUT.intro(() => { SV().seen.intro = true; G.save.write(); G.go(() => G.Scenes.map()); }));
      } else G.go(() => Place(d.to, d.toAt));
    };
    return {
      hero: h, place: id, npcs,
      setCam(x) { cx = x; },
      // is this point (game pixels) on the chalkboard frame while a share is up? The net bridge asks when the canvas is clicked.
      boardAt(px, py) { if (!P.board || !G.presence.board()) return false; const f = P.board.frame, x = px + Math.round(cx); return x >= f[0] && x <= f[0] + f[2] && py >= f[1] && py <= f[1] + f[3]; },             // for screenshots: look somewhere without walking there
      enter() { A.music('night'); A.intensity = 0; },
      update(dt) {
        t += dt; h.t += dt; h.blinkT -= dt;
        if (h.blinkT < -0.12) h.blinkT = G.rand(1.6, 4);
        h.sx = G.damp(h.sx, 1, 14, dt); h.sy = G.damp(h.sy, 1, 14, dt);
        for (let i = h.ghosts.length - 1; i >= 0; i--) { h.ghosts[i].life -= dt; if (h.ghosts[i].life <= 0) h.ghosts.splice(i, 1); }
        if (h.dashCd > 0) h.dashCd -= dt;
        const I = G.input, busy = G.transitioning();
        if (h.sit) {
          if (!busy && (I.pressed.left || I.pressed.right || I.pressed.up || I.pressed.jump)) stand();
        } else {
          const dir = busy ? 0 : (I.down.right ? 1 : 0) - (I.down.left ? 1 : 0), my = busy ? 0 : (I.down.down ? 1 : 0) - (I.down.up ? 1 : 0);
          // dash (C / shift), same as the stage bash; recharges on landing
          if (!busy && I.pressed.dash && h.canDash && h.dashCd <= 0) {
            let dx = dir, dy = my;
            if (h.ground && dy > 0) dy = 0;
            if (!dx && !dy) dx = h.face;
            const n = Math.hypot(dx, dy);
            h.ddx = dx / n; h.ddy = dy / n; h.dashT = DASH_T; h.dashCd = DASH_T + DASH_CD; h.canDash = false;
            if (dx) h.face = Math.sign(dx);
            if (h.ddy < 0) h.ground = false;
            h.sx = dy && !dx ? 0.7 : 1.45; h.sy = dy && !dx ? 1.4 : 0.65;
            A.sfx('dash');
          }
          if (h.dashT > 0) {
            h.dashT -= dt; h.vx = h.ddx * DASH; h.vy = h.ddy * DASH;
            h.ghostT -= dt;
            if (h.ghostT <= 0) { h.ghostT = 0.022; h.ghosts.push({ x: h.x, y: h.y, life: 0.2, face: h.face, sx: h.sx, sy: h.sy }); }
            if (h.dashT <= 0) { h.vx = h.ddx * SPEED * 1.1; h.vy = h.ddy < 0 ? h.ddy * 130 : 0; }
          } else {
            h.vx = G.approach(h.vx, dir * SPEED, (dir ? 900 : 1200) * dt);
            if (dir) h.face = dir;
            if (!busy && I.pressed.jump && h.ground) { h.vy = -JUMP; h.ground = false; h.sx = 0.8; h.sy = 1.25; A.sfx('jump'); }
          }
          h.x = G.clamp(h.x + h.vx * dt, 10, P.w - 10);                       // walls and room edges stop a dash too
          if (!h.ground) { if (h.dashT <= 0) h.vy += (h.vy < 0 && I.down.jump ? 830 : 1250) * dt; h.y = Math.max(30, h.y + h.vy * dt); }
          const gy = P.ground(h.x);
          if (h.ground || h.y >= gy) { if (!h.ground) { h.sx = 1.25; h.sy = 0.8; A.sfx('land'); } h.y = gy; h.vy = 0; h.ground = true; h.canDash = true; }
          h.runT = Math.abs(h.vx) > 20 ? h.runT + dt : 0;
        }
        // what is within reach: doors open with UP, the nearest free seat takes DOWN, friends talk on X
        nDoor = nSeat = nNpc = null;
        if (h.ground && !busy) {
          for (const d of P.doors) if (Math.abs(h.x - d.x) < 11) nDoor = d;
          let best = 7;
          P.tables.forEach((tb) => tb.seats.forEach((s, si) => { const d = Math.abs(h.x - s.x); if (d < best && !npcs.some((n) => n.sit === s) && !G.presence.seatTaken(s.id)) { best = d; nSeat = { tb, si, s }; } }));
          for (const n of npcs) if (n.lines && Math.abs(h.x - n.x) < (n.reach || 26)) nNpc = n;
        }
        // near the chalkboard while someone shares: UP opens the big view
        const bf = P.board ? G.presence.board() : null;
        nBoard = !!bf && h.ground && !busy && !h.sit && !nDoor && Math.abs(h.x - (P.board.frame[0] + P.board.frame[2] / 2)) < 100;
        if (nDoor && !h.sit && I.pressed.up) enter(nDoor);
        else if (nBoard && I.pressed.up) G.presence.openShare();
        else if (nSeat && !h.sit && I.pressed.down) {
          const s = nSeat.s;
          h.sit = nSeat; h.x = s.x; h.y = s.y; h.face = s.face; h.vx = 0; h.sx = 1.2; h.sy = 0.85; A.sfx('land');
          G.seated = { room: id, table: nSeat.tb.no, seat: s.id };
        }
        if (nNpc && I.pressed.attack) {
          if (talk && talk.n === nNpc && talk.shown < nNpc.lines[talk.i].length) talk.shown = nNpc.lines[talk.i].length;
          else if (talk && talk.n === nNpc) { talk.i++; talk.t = 0; talk.shown = 0; if (talk.i >= nNpc.lines.length) talk = null; }
          else talk = { n: nNpc, i: 0, t: 0, shown: 0 };
          A.sfx('uiMove');
        }
        if (talk && Math.abs(h.x - talk.n.x) > (talk.n.reach || 26) + 20) talk = null;
        if (talk) {
          talk.t += dt;
          const n = Math.min(talk.n.lines[talk.i].length, Math.floor(talk.t * 22));
          if (n > talk.shown) { if (n % 2 === 0) A.sfx('text', { p: 2 }); talk.shown = n; }
        }
        for (const n of npcs) {
          n.t += dt; n.blinkT -= dt;
          if (n.blinkT < -0.12) n.blinkT = G.rand(1.5, 4);
          if (!n.sit && Math.abs(h.x - n.x) < 60) n.face = h.x < n.x ? -1 : 1;
        }
        G.presence.update(dt, h);               // tell the others where I am, move them
        cx = G.damp(cx, camOf(), 7, dt);
        if (!busy && I.pressed.pause) { A.sfx('uiBack'); G.go(() => G.Scenes.title(true)); }
      },
      draw(g, ug) {
        const c = Math.round(cx);
        if (P.sky) G.drawBG('town', g, c, 0, G.time, 0);
        g.drawImage(P.layers[0], c, 0, W, H, 0, 0, W, H);
        for (const l of P.lights) G.light(l.x - c, l.y, l.r * (l.flick ? 1 + Math.sin(G.time * 7 + l.x) * 0.03 : 1), l.col, l.a, l.glow);
        if (P.live) P.live(g, ug, c, t);
        // a shared screen on the chalkboard, scaled to fit inside the frame (letterboxed)
        const bd = P.board, feed = bd ? G.presence.board() : null;
        if (feed) {
          g.fillStyle = '#0b1410'; g.fillRect(bd.x - c, bd.y, bd.w, bd.h);
          if (feed.ready) {
            const vw = feed.video.videoWidth, vh = feed.video.videoHeight, k = Math.min(bd.w / vw, bd.h / vh), w = Math.round(vw * k), hh = Math.round(vh * k), smooth = g.imageSmoothingEnabled;
            g.imageSmoothingEnabled = true; g.drawImage(feed.video, bd.x - c + Math.round((bd.w - w) / 2), bd.y + Math.round((bd.h - hh) / 2), w, hh); g.imageSmoothingEnabled = smooth;
          } else G.text(g, 'loading', bd.x - c + bd.w / 2, bd.y + bd.h / 2 - 3, '#7fd08a', { align: 'c', tiny: true });
        }
        // back-row sitters and anyone behind a counter go under the front layer (tables, counters, front chairs)
        const drawNpc = (n) => {
          G.drawCritter(g, n.x - c, n.y, pose({ kind: n.kind, face: n.face }, n));
          if (n.apron) {   // a green apron with the badge on the front
            const ax = Math.round(n.x - c) + (n.face > 0 ? 0 : -2), ay = Math.round(n.y);
            g.fillStyle = K; g.fillRect(ax - 3, ay - 7, 7, 6); g.fillStyle = SB.green; g.fillRect(ax - 2, ay - 6, 5, 4);
            g.fillStyle = SB.cream; g.fillRect(ax, ay - 5, 1, 1);
          }
        };
        const nBack = (n) => n.behind || (n.sit && n.sit.back), hBack = h.sit && h.sit.s.back;
        // the other people in this place (same pose language as the hero; a dash is the pale shut-eyed squash)
        const others = G.presence.peersIn(id).filter((o) => o.x - c > -24 && o.x - c < W + 24);
        const drawOther = (o) => {
          const p = pose({ kind: o.kind, face: o.face }, { sit: o.seat >= 0, ground: o.st !== 'jump' && o.st !== 'dash', vx: o.vx, vy: o.vy, runT: o.runT, t: o.t, blinkT: o.blinkT });
          if (o.st === 'dash') { p.eyes = 'shut'; p.legs = [1, 1, 1, 1]; p.col = '#ffe2c4'; }
          G.drawCritter(g, o.x - c, o.y, p);
        };
        npcs.forEach((n) => nBack(n) && drawNpc(n));
        others.forEach((o) => o.back && drawOther(o));
        const drawH = () => {
          for (const gh of h.ghosts) G.drawHero(g, gh.x - c, gh.y, { face: gh.face, col: '#ffd0b8', alpha: gh.life * 3, noEyes: true, sx: gh.sx, sy: gh.sy });
          const o = pose({ face: h.face, sx: h.sx, sy: h.sy }, h);
          if (h.dashT > 0) { o.eyes = 'shut'; o.legs = [1, 1, 1, 1]; o.col = '#ffe2c4'; }
          G.drawHero(g, h.x - c, h.y, o);
        };
        if (hBack) drawH();
        if (P.layers[1]) g.drawImage(P.layers[1], c, 0, W, H, 0, 0, W, H);
        npcs.forEach((n) => !nBack(n) && drawNpc(n));
        others.forEach((o) => !o.back && drawOther(o));
        if (!hBack) drawH();
        G.light(h.x - c, h.y - 6, 64, '#ffe6d0', 0.9, 0.06);
        G.ambient = P.ambient;
        // ----- words on the walls -----
        for (const s of P.signs) {
          const x = s.x - c;
          if (x < -80 || x > W + 80) continue;
          if (feed && s.x >= bd.frame[0] && s.x <= bd.frame[0] + bd.frame[2] && s.y >= bd.frame[1] && s.y <= bd.frame[1] + bd.frame[3]) continue;   // the board's lesson words sit under a shared screen
          const o = { align: s.left ? 'l' : s.right ? 'r' : 'c' };
          if (s.ascii) G.text(ug, s.ascii, x, s.y, s.col, Object.assign(o, { sp: s.left || s.right ? 1 : 2, tiny: !!s.tiny }));
          else G.ktext(ug, s.text, x, s.y, s.col, o);
        }
        // ----- names over the other people (a tag that would sit on another tag is nudged up) -----
        const tags = [];
        others.slice().sort((p, q) => p.x - q.x).forEach((o) => {
          const nw = G.ktextW(o.name) + 2, tw = nw + (o.teacher ? G.ktextW('강사') + 4 : 0) + (o.granted ? 9 : 0) + (o.hand ? 16 : 0) + (o.mic ? 8 : 0) + (o.sharing ? 10 : 0), x = Math.round(o.x - c);   // a raised hand sits right after the name, so it reads as that creature's
          let y = Math.round(o.y - 28);
          while (tags.some((r) => Math.abs(r.x - x) < (r.w + tw) / 2 && Math.abs(r.y - y) < 12)) y -= 12;
          tags.push({ x, y, w: tw });
          G.ktext(ug, o.name, x, y, C.paper, { align: 'c', outline: K });
          let ex = x + Math.round(nw / 2) + 3;
          if (o.mic) { ug.fillStyle = K; ug.fillRect(x - Math.round(nw / 2) - 7, y + 2, 5, 5); ug.fillStyle = '#7dff9a'; ug.fillRect(x - Math.round(nw / 2) - 6, y + 3, 3, 3); }   // a green dot before the name: the mic is on
          if (o.teacher) { G.ktext(ug, '강사', ex, y, '#ffd97a', { outline: K }); ex += G.ktextW('강사') + 4; }   // the teacher: a gold 강사 after the name
          if (o.granted) { drawIcon(ug, STAR, ex + 1, y + 2, '#ffd97a'); ex += 9; }                                  // a student who may speak: a gold star
          if (o.sharing) { drawIcon(ug, SCREEN_IC, ex, y + 2, '#7fd0ff'); ex += 9; }
          if (o.hand) drawHand(ug, ex + 4, y + 1, t);
          if (o.say) drawSay(ug, x, y - (o.hand ? 12 : 2), o.say);
        });
        if (feed) G.ktext(ug, feed.name + '님의 화면', Math.round(bd.x + bd.w / 2 - c), bd.y + bd.h + 8, '#c6f2a8', { align: 'c', outline: K });
        // ----- place name -----
        if (t < 3.2) {
          const k = G.ease.out(G.clamp(t / 0.4, 0, 1)) * (1 - G.ease.in(G.clamp((t - 2.7) / 0.5, 0, 1)));
          const w = G.ktextW(P.name) + 22, x = Math.round(-w + (w + 6) * k);
          G.panel(ug, x, 8, w, 17, '#17131f', '#3a3346');
          ug.fillStyle = '#7fd08a'; ug.fillRect(x + 2, 9, 2, 15);
          G.ktext(ug, P.name, x + 9, 11, C.paper);
        }
        // ----- prompts over the hero's head -----
        const rows = [];
        if (nDoor && !h.sit) rows.push(['UP', nDoor.label]);
        if (nSeat && !h.sit) {
          rows.push(['DOWN', nSeat.s.teacher ? '강사로 앉기' : '앉기']);
          const mx = nSeat.s.x - c, my = nSeat.s.y - (nSeat.s.back ? 20 : 4);   // a little arrow over the seat it will take
          ug.fillStyle = K; ug.fillRect(mx - 3, my - 1, 7, 1); for (let j = 0; j < 4; j++) ug.fillRect(mx - 3 + j, my + j, 7 - j * 2, 1);
          ug.fillStyle = '#c6f2a8'; for (let j = 0; j < 3; j++) ug.fillRect(mx - 2 + j, my + j, 5 - j * 2, 1);
        }
        if (h.sit) rows.push(['< >', '일어나기']);
        if (nNpc && !talk) rows.push(['X', '말 걸기']);
        if (nBoard && !talk) rows.push(['UP', '크게 보기']);
        if (G.presence.myHand) drawHand(ug, Math.round(h.x - c), Math.round(h.y - 26), t);
        const mySay = G.presence.mySay;
        if (mySay) drawSay(ug, Math.round(h.x - c), Math.round(h.y - 17 - (G.presence.myHand ? 10 : 0)), mySay);
        if (G.presence.myGranted) drawIcon(ug, STAR, Math.round(h.x - c) - 14, Math.round(h.y - 12), '#ffd97a');   // I may speak
        if (G.presence.myMic) { const mx = Math.round(h.x - c) + 9, my = Math.round(h.y - 12); ug.fillStyle = K; ug.fillRect(mx - 1, my - 1, 5, 5); ug.fillStyle = '#7dff9a'; ug.fillRect(mx, my, 3, 3); }   // my own mic is on
        // the latest chat lines fade at the bottom while the chat panel is closed
        G.presence.recentChat().forEach((l, i, arr) => { ug.globalAlpha = l.alpha; G.ktext(ug, fitText(l.name + ': ' + l.text, 220), 4, H - 14 - (arr.length - 1 - i) * 12, l.mine ? '#ffd97a' : C.paper, { outline: K }); });
        ug.globalAlpha = 1;
        // the hints sit over the hero's head; where a tag (or the raised hand) would be covered they go below the feet instead
        const geom = rows.map(([key, label], i) => {
          const kw = Math.max(11, G.textW(key, { tiny: true }) + 6), w = kw + 3 + G.ktextW(label);
          return { key, label, kw, w, x: Math.round(G.clamp(h.x - c - w / 2, 4, W - w - 4)), i };
        });
        const hintTop = Math.round(h.y - 32 - Math.max(0, rows.length - 1) * 15), hintBot = Math.round(h.y - 32) + 12;
        const covered = geom.some((q) => tags.some((r) => Math.abs(r.x - (q.x + q.w / 2)) < (r.w + q.w) / 2 && r.y + 11 > hintTop && r.y < hintBot)) || ((G.presence.myHand || mySay) && rows.length > 0);
        geom.forEach((q) => {
          const y = covered ? Math.round(h.y + 5 + q.i * 15) : Math.round(h.y - 32 - q.i * 15);
          G.keycap(ug, q.x, y, q.key);
          G.ktext(ug, q.label, q.x + q.kw + 3, y - 1, C.paper, { outline: K });
        });
        // ----- talk bubble (the same box the stage signs use) -----
        if (talk) {
          const n = talk.n, k = G.critter(n.kind), name = k.ko + (n.role ? ' ' + n.role : ''), line = n.lines[talk.i];
          const lines = G.kwrap(line, 190), bw = Math.max(G.ktextW(name), ...lines.map(G.ktextW)) + 22, bh = lines.length * 13 + 20;
          const x = Math.round(G.clamp(n.x - c - bw / 2, 4, W - bw - 4)), y = Math.max(4, Math.round(n.y - 26 - bh));
          G.panel(ug, x, y, bw, bh, '#17131f', C.paper, '#0d0a12');
          ug.fillStyle = C.paper; ug.fillRect(G.clamp(n.x - c, x + 4, x + bw - 6), y + bh, 3, 2);
          G.ktext(ug, name, x + 7, y + 4, k.hi === '#ffffff' ? '#c9bfd8' : k.hi);
          let left = talk.shown;
          lines.forEach((ln, i) => { const part = ln.slice(0, Math.max(0, left)); left -= ln.length + 1; if (part) G.ktext(ug, part, x + 7, y + 17 + i * 13, C.paper); });
          if (talk.shown >= line.length && ((t * 2.5) | 0) % 2) G.text(ug, '▸', x + bw - 9, y + bh - 9, C.paper);
        }
      },
    };
  }
  G.Town = Place;
  G.PLACES = PLACES;
})();
